module.exports = __webpack_public_path__ + "static/media/behandlungen.d3362761.jpg";